import moment from 'moment';
import numbro from 'numbro';
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Chart, ChartCanvas } from 'react-stockcharts';
import { XAxis, YAxis } from 'react-stockcharts/lib/axes';
import {
  CrossHairCursor,
  MouseCoordinateX,
  MouseCoordinateY,
} from 'react-stockcharts/lib/coordinates';
import { fitWidth } from 'react-stockcharts/lib/helper';
import { discontinuousTimeScaleProvider } from 'react-stockcharts/lib/scale';
import { LineSeries } from 'react-stockcharts/lib/series';
import { HoverTooltip } from 'react-stockcharts/lib/tooltip';
import { last } from 'react-stockcharts/lib/utils';

import { uiHelpers } from '../helpers';
import { xGrid, yGrid } from '../helpers/chart.helper';

interface Props {
  values: any[];
  title: string;
  formatter: string | Record<string, unknown>;
}
interface States {
  hasError: boolean;
}

class SimpleLineChart extends PureComponent<
  Props & {
    // fitWidth()
    width: number;
    ratio: number;
  },
  States
> {
  constructor(props) {
    super(props);

    this.state = { hasError: false };
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) return <></>;
    const { values, title, formatter: _formatter, width, ratio } = this.props;

    const formatter = v => numbro(v).format(_formatter);

    const tooltipContent = ({ currentItem }) => {
      return {
        x: uiHelpers.formatDateLocal(currentItem.x),
        y: [
          {
            label: title,
            value: formatter(currentItem.value),
          },
        ].filter(line => line.value),
      };
    };

    for (const d of values) {
      d.x = moment(d.date.toString(), 'YYYYMMDD').toDate();
    }

    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(
      d => d.x
    );
    const { data, xScale, xAccessor, displayXAccessor } =
      xScaleProvider(values);

    const xExtents = [
      Math.max(0, xAccessor(last(data)) - 120),
      xAccessor(last(data)),
    ];

    return (
      <div>
        <ChartCanvas
          ratio={ratio}
          width={width}
          margin={{ left: 100, right: 50, top: 30, bottom: 30 }}
          height={500}
          type="hybrid"
          seriesName="Gain Loss"
          xExtents={xExtents}
          data={data}
          xAccessor={xAccessor}
          displayXAccessor={displayXAccessor}
          xScale={xScale}
          clamp="both"
        >
          <Chart id={1} yExtents={[d => d.value]}>
            <XAxis {...xGrid(500)} axisAt="bottom" orient="bottom" />
            <YAxis
              {...yGrid(width - 50)}
              axisAt="left"
              orient="left"
              tickFormat={formatter}
            />
            <MouseCoordinateX
              at="bottom"
              orient="bottom"
              displayFormat={uiHelpers.formatDateLocal}
            />
            <MouseCoordinateY
              at="left"
              orient="left"
              displayFormat={formatter}
            />
            <LineSeries
              yAccessor={d => d.value}
              stroke="#000000"
              strokeWidth={2}
            />
            <HoverTooltip tooltipContent={tooltipContent} fontSize={15} />
          </Chart>
          <CrossHairCursor />
        </ChartCanvas>
      </div>
    );
  }
}

export default withTranslation()(
  connect()(fitWidth(SimpleLineChart))
) as React.ComponentType<Props>; // fitWidth will return the wrong type
